import { Phone, Clock } from "lucide-react";

export default function TopBar() {
  return (
    <div data-testid="top-bar" className="bg-navy text-white text-sm hidden md:block fixed top-0 left-0 right-0 z-[60]">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl flex items-center justify-between py-2">
        <div className="flex items-center gap-6">
          <a href="tel:+917075659696" data-testid="topbar-phone-1" className="flex items-center gap-1.5 hover:text-teal transition-colors">
            <Phone className="w-3.5 h-3.5" strokeWidth={1.5} />
            <span>70756 59696</span>
          </a>
          <a href="tel:+917842988596" data-testid="topbar-phone-2" className="flex items-center gap-1.5 hover:text-teal transition-colors">
            <Phone className="w-3.5 h-3.5" strokeWidth={1.5} />
            <span>78429 88596</span>
          </a>
        </div>
        <div className="flex items-center gap-1.5">
          <Clock className="w-3.5 h-3.5" strokeWidth={1.5} />
          <span>Consultation Hours: 9 AM to 9 PM</span>
        </div>
      </div>
    </div>
  );
}
